import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, allowLeader = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly) {
    const allowed = user.role === "admin" || (allowLeader && user.role === "leader");
    if (!allowed) return <Navigate to="/" replace />;
  }
  return children;
}
